import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';
@Component({
  selector: 'app-admin-cooperation-codes',
  templateUrl: './admin-cooperation-codes.component.html',
  styleUrls: ['./admin-cooperation-codes.component.css']
})
export class AdminCooperationCodesComponent implements OnInit {

  constructor( 
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private route:ActivatedRoute,
    private authService: AuthService) { }
  companies = [];
  billings = [];
  authToken = localStorage.getItem('auth');
  finalSum = 0;
  routeID = this.route.snapshot.params.id;
  code_obj = [];

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  ngOnInit(): void {
    this.fetchBilling(false);
  }

  fetchBilling(use_inputs) {
    //Epoch time

    //Get first day of the month at 00:00:00
    var date = new Date();
    var epoch = date.getTime();
    if(use_inputs) {

      var start = (<HTMLInputElement>document.getElementById("start")).value;
      var end = (<HTMLInputElement>document.getElementById("end")).value;

      var start_date = new Date(start);
      var end_date = new Date(end);

      var firstDay = new Date(start_date.getFullYear(), start_date.getMonth(), start_date.getDate(), 0, 0, 0);
      var firstDayEpoch = firstDay.getTime();

      var endDay = new Date(end_date.getFullYear(), end_date.getMonth(), end_date.getDate(), 0, 0, 0);
      var endDayEpoch = endDay.getTime();

      var end_path = '?start=' + firstDayEpoch + '&end=' + endDayEpoch;
    }
    else{
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0);
      var firstDayEpoch = firstDay.getTime();
  
      //Get current state of the month
      var date = new Date();
      var epoch = date.getTime() + 86400000;
  
      var end_path = '?start=' + firstDayEpoch + '&end=' + epoch;
  
      (<HTMLInputElement>document.getElementById("start")).value = firstDay.toISOString().substring(0, 10);
      (<HTMLInputElement>document.getElementById("end")).value = date.toISOString().substring(0, 10);
    }


    this.http.get(environment.ADMIN_COOPERATION_CODES + end_path, this.httpOptions).subscribe(
      (res: any) => {
        console.log(res);
        if(res.status == 200 ) {
          this.billings = res.message;
          var code_o = {};
          //Group by same code to code obj
          code_o = this.billings.reduce((acc, obj) => {
            var key = obj.code.toUpperCase();
            //remove spacings
            key = key.replace(/\s/g, '');
            if (!acc[key]) {
              acc[key] = [];
            }
            acc[key].push(obj);
            return acc;
          }, {});

          
          //Now change it to array which tells how many times code has been used
          var code_arr = [];
          for (const key in code_o) {
            if (Object.prototype.hasOwnProperty.call(code_o, key)) {
              const element = code_o[key];
              code_arr.push({code: key, times: element.length});
            }
          }

          //Sort so that most used code is first
          code_arr.sort((a, b) => b.times - a.times);

          this.code_obj = code_arr;


          console.log(this.code_obj)

         
        }
        else {
          console.log('buu')
          this.billings = [];
        }
        
      }, (err: any) => {

      }
    )
  

}

}
